import LockTableCellRenderer from "./LockTableCellRenderer";

export default class InactiveCellRenderer extends LockTableCellRenderer {
    constructor(additionalCssClass) {
        super();
        this.cellClass = "inactiveCell";
        if (additionalCssClass)
            this.cellClass += " " + additionalCssClass;
    }

    getCellClassName(cell) {
        return this.cellClass;
    }

    getLastCellRightBorderClassName() {
        return "";
    }

    getWeekSeparatorClass(cell) {
        return "";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/InactiveCellRenderer.js